module.exports = __webpack_public_path__ + "img/home_company_top.abe8ef3a.png";